<template>
    <div class="banner">
      <el-carousel v-if="bannerList.length > 0" :height="height" :autoplay="autoplayStatus" :interval="5000" :indicator-position="bannerList.length > 1 ? '' : 'none'" :arrow="bannerList.length > 1 ? 'hover' : 'never'">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img v-if="item.type === 0" :src="item.imgUrl" alt="banner" class="banner-img" @click="onBannerClick(item)" />
          <div v-else :style="`height: 100%; background: url(${item.imgUrl}) no-repeat center center / cover;`">
            <video :src="item.videoUrl" muted controls height="100%" width="100%" @play="onVideoStart" @pause="onVideoPause" @ended="onVideoEnded"></video>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useHttpApi } from '~/composables/useApi'
import { ElCarousel, ElCarouselItem } from 'element-plus'
interface BannerItem {
    id: number
    imgUrl: string
    videoUrl?: string
    type: 0 | 1
}
const props = defineProps({
    height: {
        type: String,
        default: '470px'
    },
    fromType: {
        type: String,
        default: 'index'
    }
})
const { getBannerListApi } = useHttpApi()
const bannerList = ref([] as BannerItem[])
const autoplayStatus = ref(true)
const getBannerList = async () => {
    const res = await getBannerListApi(props.fromType)
    bannerList.value = res?.data?.data || []
}

// 点击banner
const onBannerClick = (item: BannerItem) => {
    if(!item.linkUrl){
        return;
    }
    window.open(item.linkUrl, '_blank')
}
// 视频开始播放
const onVideoStart = () => {
    autoplayStatus.value = false
    console.log('视频开始播放');
  }

  // 视频暂停播放
  const onVideoPause = () => {
    autoplayStatus.value = true

    console.log('视频暂停播放');
  }

  // 视频播放完成
  const onVideoEnded = () => {
    autoplayStatus.value = true
    console.log('视频已播放完成');
  }
onMounted(() => {
    getBannerList()
})
</script>
<style scoped lang="scss">
.banner {
//   height: 470px;
  min-height: 70px;
  background: #667BFB;
  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
::v-deep .el-carousel__button {
  widows: 50px;
  height: 5px;
  border-radius: 3px;
}
</style>